<template>
  <div class="manager-detail-audit-log">
    <div class="tabs-container">
      <div
        :class="['tab-item', curTab === item.value ? 'active' : '']"
        v-for="item in tabList"
        :key="item.value"
        @click="handleChangeTab(item.value)"
      >
        <img :src="curTab === item.value ? item.iconActive : item.iconDefault" alt="" />
        <span>{{ `${item.label} (${item.count})` }}</span>
      </div>
    </div>

    <div class="log-list-container">
      <div class="empty-box" v-if="logList.length === 0">
        暂无数据
      </div>
      <div class="log-item" v-for="(item, index) in logList" :key="item.id">
        <div class="log-main" @click="handleChangeShowDetail(index)">
          <div class="log-icon-box">
            <img :src="statusList[item.status].mainIcon" alt="" />
            <span :class="statusList[item.status].colorClass">{{ statusList[item.status].label }}</span>
          </div>
          <div class="log-main-detail">
            <div class="main-title">{{ item.addrName || '--' }}</div>
            <el-collapse-transition>
              <div class="main-detail" v-show="!item.showDetail">
                <div class="prop-item">
                  <span class="prop-label">审核时间：</span>
                  <span class="prop-value">{{ item.status == 1 ? '--' : item.auditTime || '--' }}</span>
                </div>
                <div class="prop-item">
                  <span class="prop-label">审核人：</span>
                  <span class="prop-value">{{ item.status == 1 ? '--' : item.auditName || '--' }}</span>
                </div>
              </div>
            </el-collapse-transition>
          </div>
          <div class="dropdown-icon">
            <ArrowDown :class="[item.showDetail ? 'rotate-180' : '']" />
            <!-- <i :class="['el-icon-arrow-down', item.showDetail ? 'rotate-180' : '']"></i> -->
          </div>
        </div>
        <el-collapse-transition>
          <div class="main-list-box" v-show="item.showDetail">
            <div class="list-line"></div>
            <div class="audit-item" v-for="log in item.auditRecords" :key="log.id">
              <div :class="['audit-dot', statusList[log.auditStatus].bgClass]"></div>
              <div class="item-pane">
                <div class="item-status">
                  <img :src="statusList[log.auditStatus].logIcon" alt="">
                  <span :class="[statusList[log.auditStatus].colorClass]">{{ statusList[log.auditStatus].label }}</span>
                </div>
                <div class="prop-item time-item">
                  <span class="prop-label">审核时间：</span>
                  <span class="prop-value">{{ log.auditStatus == 1 ? '--' : log.auditTime || '--' }}</span>
                </div>
                <div class="prop-item">
                  <span class="prop-label">审核区域：</span>
                  <span class="prop-value">{{ log.addrName || '--' }}</span>
                </div>
                <div class="prop-item">
                  <span class="prop-label">审核人：</span>
                  <span class="prop-value">{{ log.auditStatus == 1 ? '--' : log.auditName || '--' }}</span>
                </div>
                <div class="prop-item">
                  <span class="prop-label">审核说明：</span>
                  <span class="prop-value">{{ log.auditReason || '--' }}</span>
                </div>
              </div>
            </div>
          </div>
        </el-collapse-transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import iconLogPass from '@/assets/img/icon/manager-check-pass.png'
import iconLogUnpass from '@/assets/img/icon/manager-check-unpass.png'
import iconLogChecking from '@/assets/img/icon/manager-checking.png'

import iconPassActive from '@/assets/img/icon/manager-tab-pass-active.png'
import iconPassDefault from '@/assets/img/icon/manager-tab-pass-default.png'
import iconUnpassError from '@/assets/img/icon/manager-tab-unpass-error.png'
import iconUnpassActive from '@/assets/img/icon/manager-tab-unpass-active.png'
import iconUnpassDefault from '@/assets/img/icon/manager-tab-unpass-default.png'
import iconCheckingActive from '@/assets/img/icon/manager-tab-checking-active.png'
import iconCheckingDefault from '@/assets/img/icon/manager-tab-checking-default.png'
import iconCheckingWarning from '@/assets/img/icon/manager-tab-checking-warning.png'

export default {
  props: {
    detailData: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      iconLogPass,
      iconLogUnpass,
      iconLogChecking,

      iconPassActive,
      iconPassDefault,
      iconUnpassError,
      iconUnpassActive,
      iconUnpassDefault,
      iconCheckingActive,
      iconCheckingDefault,
      iconCheckingWarning,

      curTab: '2',
      tabList: [
        { value: '2', label: '已通过', count: 0, iconActive: iconPassActive, iconDefault: iconPassDefault },
        { value: '1', label: '审核中', count: 0, iconActive: iconCheckingActive, iconDefault: iconCheckingDefault },
        { value: '3', label: '未通过', count: 0, iconActive: iconUnpassActive, iconDefault: iconUnpassDefault },
      ],

      statusList: [
        {},
        { value: 1, label: '审核中', colorClass: 'color-warning', bgClass: 'bgcolor-warning', logIcon: iconCheckingWarning, mainIcon: iconLogChecking },
        { value: 0, label: '已通过', colorClass: 'color-pass', bgClass: 'bgcolor-pass', logIcon: iconPassDefault, mainIcon: iconLogPass },
        { value: 2, label: '未通过', colorClass: 'color-error', bgClass: 'bgcolor-error', logIcon: iconUnpassError, mainIcon: iconLogUnpass },
      ],
      logList: [],
    }
  },
  created() {
    this.getLogList()
  },
  watch: {
    // 监听
    curTab() {
      this.getLogList()
    },
    detailData: {
      deep: true,
      handler(val) {
        this.getLogList()
      }
    }
  },
  methods: {
    ...mapActions([ 'fetchData' ]),
    // 获取审核记录列表
    getLogList() {
      for (let i = 0; i < this.tabList.length; i++) {
        if (this.detailData.reviewStatus == this.tabList[i].value) {
          this.tabList[i].count = 1
          break
        }
      }

      if (this.curTab != this.detailData.reviewStatus) {
        this.logList = []
        return
      }

      let log = {
        status: this.detailData.reviewStatus,
        addrName: '--',
        showDetail: false,
        auditName: this.detailData.reviewerName || '--',
        auditTime: this.detailData.reviewTime || '--',
        auditRecords: [{
          id: 'FIRST_ID',
          auditName: this.detailData.reviewerName || '--',
          auditTime: this.detailData.reviewTime || '--',
          addrName: '--',
          auditStatus: this.detailData.reviewStatus,
          auditReason: this.detailData.reviewInfo,
        }]
      }
      this.logList = [log]

      // let url = 'SAAS.OPRATER_AUDIT_LOG_LIST'
      // let params = { params: JSON.stringify({ id: this.detailData.id, jyzbm: this.detailData.jyzbm, isExamine: this.curTab }) }
      // this.fetchData({
      //   url,
      //   method: 'get',
      //   params,
      // }).then(res => {
      //   let countList = [res.passCount, res.needAuditCount, res.noPassCount]
      //   this.tabList.forEach((item, index) => {
      //     item.count = countList[index]
      //   })

      //   let logList = res.data || []
      //   logList.forEach(item => {
      //     item.showDetail = false
      //     item.addrName = item.neighborCmmName || item.streetOfficeName || item.areaName || item.cityName || item.provinceName
      //     item.status = item.auditStatus || 1

      //     item.auditRecords = item.auditRecords || []
      //     let addrName = `${item.provinceName || ''} ${item.cityName || ''} ${item.areaName || ''} ${item.streetOfficeName || ''} ${item.neighborCmmName || ''}`
      //     item.auditRecords.unshift({ // 将记录塞到最前面
      //       id: 'FIRST_ID',
      //       auditName: item.auditName,
      //       auditTime: item.auditTime,
      //       addrName,
      //       auditStatus: item.status,
      //       auditReason: item.auditReason,
      //     })
      //     item.auditRecords.forEach(log => { // 历史记录的审核区域其实是一样的
      //       log.addrName = addrName
      //     })
      //   })

      //   this.logList = logList
      // })
    },
    // 处理tab变更
    handleChangeTab(tab) {
      this.curTab = tab
    },
    // 处理详情的展开与否
    handleChangeShowDetail(idx) {
      this.logList[idx].showDetail = !this.logList[idx].showDetail
    }
  },
}
</script>

<style lang="less" scoped>
@colorPass: rgba(1, 192, 192, 1);
@colorError: rgba(241, 34, 48, 1);
@colorWarning: rgba(206, 131, 19, 1);

.manager-detail-audit-log {
  margin: 0 auto;
  padding-top: 10px;
  padding-bottom: 40px;
  width: 90%;
  .tabs-container {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .tab-item {
      display: flex;
      align-items: center;
      padding: 5px 15px;
      margin-right: 15px;
      font-size: 12px;
      color: rgba(1, 192, 192, 1);
      border-radius: 16px;
      cursor: pointer;
      transition: color 200ms linear, background-color 100ms linear;
      &.active {
        color: white;
        background-color: rgba(1, 192, 192, 1);
      }
      img {
        max-width: 20px;
        max-height: 20px;
        margin-right: 5px;
      }
      span {
        margin-top: 2px;
      }
    }
  }
  .log-list-container {
    max-height: calc(~'80vh - 214px');
    overflow-y: auto;
    padding-bottom: 20px;
  }
  .empty-box {
    text-align: center;
    width: 100%;
    height: 100px;
    line-height: 100px;
  }
  .log-item {
    padding: 10px 20px;
    margin-bottom: 20px;
    background-color: rgba(244, 251, 255, 1);
    &:last-of-type {
      margin-bottom: 0px;
    }
    .log-main {
      display: flex;
      cursor: pointer;
    }
    .log-icon-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 5px;
      width: 50px;
      img {
        max-width: 40px;
        max-height: 40px;
        margin-bottom: 5px;
      }
    }
    .log-main-detail {
      flex: 1;
      color:#000;
      .main-title {
        margin-top: 9px;
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 15px;
      }
      .prop-item {
        display: flex;
        .prop-label {
          color: #959697;
        }
      }
    }
    .dropdown-icon {
      width: 30px;
      font-size: 22px;
      color: black;
      i {
        transition: transform 250ms linear;
      }
    }
    .main-list-box {
      position: relative;
      padding-top: 10px;
    }
    .list-line {
      position: absolute;
      top: 0px;
      left: 25px;
      width: 1px;
      height: 100%;
      border-right: 1px dashed rgba(201, 201, 201, 1);
    }
    .audit-item {
      display: flex;
      margin-bottom: 10px;
      .audit-dot {
        margin-left: 19px;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        margin-right: 24px;
        z-index: 9;
      }
      .item-pane {
        position: relative;
        padding: 20px;
        flex: 1;
        background-color: white;
        border: 1px solid rgba(229, 229, 229, 1);
        border-radius: 8px;
      }
      .item-status {
        position: absolute;
        top: 20px;
        right: 20px;
        display: flex;
        align-items: center;
        img {
          max-width: 25px;
          max-height: 25px;
          margin-right: 10px;
        }
        span {
          font-size: 14px;
        }
      }
      .prop-item {
        display: flex;
        margin-bottom: 10px;
        .prop-label {
          display: block;
          text-align: right;
          width: 80px;
          color: rgba(153, 153, 153, 1);
        }
        .prop-value {
          flex: 1;
          text-align: justify;
          color: #000;

        }
      }
      .prop-item.time-item {
        margin-bottom: 20px;
        .prop-label {
          color: black;
        }
        .prop-value {
          font-size: 18px;
          font-weight: bold;
          color: black;
        }
      }
    }
  }
}

.rotate-180 {
  transform: rotate(-180deg);
}
.color-pass {
  color: @colorPass;
}
.color-error {
  color: @colorError;
}
.color-warning {
  color: @colorWarning;
}
.bgcolor-pass {
  background-color: @colorPass;
}
.bgcolor-error {
  background-color: @colorError;
}
.bgcolor-warning {
  background-color: @colorWarning;
}
</style>